import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5ebd51e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container px-0 py-9" }
const _hoisted_2 = { class: "forecast-guide-container" }
const _hoisted_3 = { class: "forecast-guide-content-container" }
const _hoisted_4 = {
  class: "forecast-guide-content",
  id: "content-box-one"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "forecast-img",
  src: "https://images.eu.ctfassets.net/vhb8aakerf77/PUBJj7UjMS5mMUWPVC8DN/fe0cbb507507c87c35599d24306ad96e/Virksomhed_icon.svg",
  alt: ""
}, null, -1))
const _hoisted_6 = { class: "content-description" }
const _hoisted_7 = { class: "title-header" }
const _hoisted_8 = { class: "content-description-text" }
const _hoisted_9 = {
  class: "forecast-guide-content",
  id: "content-box-two"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "forecast-img",
  src: "https://images.eu.ctfassets.net/vhb8aakerf77/1gJe2mqRv9HxV7p1uP1CxJ/68acde8153ebd23b4d990e7168eaf58b/Overblik_ikon.svg",
  alt: ""
}, null, -1))
const _hoisted_11 = { class: "content-description" }
const _hoisted_12 = { class: "title-header" }
const _hoisted_13 = { class: "content-description-text" }
const _hoisted_14 = {
  class: "forecast-guide-content",
  id: "content-box-three"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "forecast-img",
  src: "https://images.eu.ctfassets.net/vhb8aakerf77/4aR3mXN2seWHYNETOlDMs0/2a15d90ef6623201d99827d8bf9b8508/Dokument_ikon.svg",
  alt: ""
}, null, -1))
const _hoisted_16 = { class: "content-description" }
const _hoisted_17 = { class: "title-header" }
const _hoisted_18 = { class: "content-description-text" }
const _hoisted_19 = {
  class: "forecast-guide-content",
  id: "content-box-four"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "forecast-img",
  src: "https://images.eu.ctfassets.net/vhb8aakerf77/5dOVjeJfDZYv9n8nohW44f/47e843d6c06eea2c3a9c06a2a4396fff/Excel_icon.png",
  alt: ""
}, null, -1))
const _hoisted_21 = { class: "content-description" }
const _hoisted_22 = { class: "title-header" }
const _hoisted_23 = { class: "content-description-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SimpleText = _resolveComponent("SimpleText")!
  const _component_RichText = _resolveComponent("RichText")!
  const _component_SharedHeader = _resolveComponent("SharedHeader")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_SharedHeader, null, {
      firstColumn: _withCtx(() => [
        _createElementVNode("h1", null, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.forecast-header-title" })
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_RichText, { "text-key": "forecast.forecast-header-text" })
        ]),
        _createElementVNode("span", null, [
          _createElementVNode("button", {
            type: "button",
            class: "button button-primary",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openLink(_ctx.getContentfulString('forecast.guides.download-link.pdf-complete-guide'))))
          }, [
            _createVNode(_component_SimpleText, { "text-key": "forecast.forecast-download-guide-button-text" })
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "button button-secondary",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openLink(_ctx.getContentfulString('forecast.guides.download-link.pdf-step-by-step-guide'))))
          }, [
            _createVNode(_component_SimpleText, { "text-key": "forecast.forecast-download-guide-button2-text" })
          ])
        ])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, [
          _createVNode(_component_SimpleText, { "text-key": "forecast.forecast.sub-title" })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("h3", _hoisted_7, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.guides.content-one-description-header" })
              ]),
              _createElementVNode("p", _hoisted_8, [
                _createVNode(_component_RichText, { "text-key": "forecast.guides.content-one-description-text" })
              ]),
              _createVNode(_component_router_link, {
                to: "/forecast/calculate-forecast",
                class: "button button-primary col"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SimpleText, { "text-key": "forecast.forecast.button-link.name" })
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("h3", _hoisted_12, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.guides.content-two-description-header" })
              ]),
              _createElementVNode("p", _hoisted_13, [
                _createVNode(_component_RichText, { "text-key": "forecast.guides.content-two-description-text" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("h3", _hoisted_17, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.guides.content-three-description-header" })
              ]),
              _createElementVNode("p", _hoisted_18, [
                _createVNode(_component_RichText, { "text-key": "forecast.guides.content-three-description-text" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("h3", _hoisted_22, [
                _createVNode(_component_SimpleText, { "text-key": "forecast.guides.content-four-description-header" })
              ]),
              _createElementVNode("p", _hoisted_23, [
                _createVNode(_component_RichText, { "text-key": "forecast.guides.content-four-description-text" })
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}